import { TDrawModel } from '../../draw.model';
import { TTimelieWrapper } from './draw.tasks';

export const drawLefNav = (drawModel: TDrawModel, timelineWrapper: TTimelieWrapper) => {
  const bodyHeight = drawModel.timelineModel.comptedEntities.totalEntities * drawModel.layout.entityHeight;
  const leftNav = timelineWrapper
    .selectAll('.left-nav')
    .data([drawModel])
    .join('svg')
    .classed('left-nav', true)
    .attr('width', drawModel.layout.margin.left)
    .attr('height', bodyHeight)
    .style('position', 'sticky')
    .style('left', '0')
    .style('top', drawModel.layout.headerHeight)
    .style('z-index', '5');

  addLeftNavBackground(drawModel, leftNav);
  addBackgroundLeftNav(drawModel, leftNav);
  addRightBorderLeftNav(drawModel, leftNav);
  return leftNav;
};

const addLeftNavBackground = (drawModel: TDrawModel, leftNav: ReturnType<typeof drawLefNav>) => {
  const { entities } = drawModel.timelineModel;
  const { entityHeight } = drawModel.layout;

  const sectionData = entities.map((entity, index) => ({
    y: entities.slice(0, index).reduce((acc, curr) => acc + curr.entities.length * entityHeight, 0),
    height: entity.entities.length * entityHeight,
    fill: entity.backgroundColor ?? '#f8f9f9',
  }));

  return leftNav
    .selectAll('.overlay')
    .data(sectionData)
    .join('rect')
    .attr('width', drawModel.layout.margin.left)
    .attr('height', (d) => d.height)
    .attr('y', (d) => d.y)
    .attr('fill', (d) => d.fill)
    .classed('overlay', true);
};

const addRightBorderLeftNav = (drawModel: TDrawModel, leftNav: ReturnType<typeof drawLefNav>) => {
  return leftNav
    .selectAll('.right-marker')
    .data([drawModel])
    .join('line')
    .classed('right-marker', true)
    .style('stroke', '#e1e1e1')
    .style('stroke-width', 1)
    .attr('x1', drawModel.layout.margin.left)
    .attr('y1', 0)
    .attr('x2', drawModel.layout.margin.left)
    .attr('y2', drawModel.timelineModel.comptedEntities.totalEntities * drawModel.layout.entityHeight);
};

const addBackgroundLeftNav = (drawModel: TDrawModel, leftNav: ReturnType<typeof drawLefNav>) => {
  return leftNav.selectAll('.left-nav-background').data([drawModel]).join('g').classed('left-nav-background', true);
};
